import { render, staticRenderFns } from "./06_1_СontrolBodyForm.vue?vue&type=template&id=41541bce&scoped=true&"
import script from "./06_1_СontrolBodyForm.vue?vue&type=script&lang=js&"
export * from "./06_1_СontrolBodyForm.vue?vue&type=script&lang=js&"
import style0 from "./06_1_СontrolBodyForm.vue?vue&type=style&index=0&id=41541bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41541bce",
  null
  
)

export default component.exports